import React, { Children } from 'react';
import ReactDOM from 'react-dom';

var userBrowser = navigator.userAgent || navigator.vendor || window.opera;

class TabsSliderMenuPortal extends React.Component {
  constructor(props) {
    super(props);
    this.el = document.createElement('div');
  }

  componentDidMount() {
    const modalRoot = document.getElementById('tabs-menu-root');

    modalRoot.appendChild(this.el);
  }

  render() {
    return ReactDOM.createPortal(this.props.children, this.el);
  }
}

const TabsSliderMenuContainer = React.forwardRef(
  ({ portal, children, _className, onTouchMove, onTouchStart }, ref) => {
    return portal ? (
      <TabsSliderMenuPortal>
        <div
          ref={ref}
          onTouchMove={onTouchMove}
          onTouchStart={onTouchStart}
          className={_className}
        >
          {children}
        </div>
      </TabsSliderMenuPortal>
    ) : (
      <div
        ref={ref}
        onTouchMove={onTouchMove}
        onTouchStart={onTouchStart}
        className={_className}
      >
        {children}
      </div>
    );
  }
);

const TabsSliderMenu = React.forwardRef(
  ({ children, label, onClick, index, _className }, ref) => {
    return (
      <li
        ref={ref}
        style={{ marginRight: 30 }}
        className={_className}
        onClick={onClick}
      >
        <button className='tabsSlider--menuLink'>{label}</button>
      </li>
    );
  }
);

const TabsSliderContainer = React.forwardRef(
  ({ children, style, _className }, ref) => {
    return (
      <div ref={ref} className={_className} style={style}>
        {children}
      </div>
    );
  }
);

const TabsSliderTab = React.forwardRef(
  ({ children, _className, currentIndex, ...props }, ref) => {
    let translateX = 0 + (props.index === currentIndex ? 0 : 100);
    translateX *= props.index < currentIndex ? -1 : 1;

    return (
      <div
        ref={ref}
        className={_className}
        style={{
          ...props.style,
          display: Math.abs(props.index - currentIndex) > 2 ? 'none' : 'flex',
          transform: `translate3d(${translateX}%, 0, 0)`,
          // opacity: props.index === currentIndex ? 1 : 0,
        }}
        {...props}
      >
        {children}
      </div>
    );
  }
);

class TabsSlider extends React.Component {
  constructor(props) {
    super(props);

    this.tabs = React.createRef([]);
    this.tabs.current = [];
    this.menus = React.createRef([]);
    this.menus.current = [];
    this.tabsContainer = React.createRef();
    this.menusContainer = React.createRef();
    this.menuUnderline = React.createRef();

    this.callbacks = {
      initialized: () => {
        if (typeof props.onInitialized === 'function') {
          props.onInitialized();
        }
      },
      tabSelected: () => {
        if (typeof props.tabsSelected === 'function') {
          props.tabSelected();
        }
      },
    };

    // this.init = function initTabsSliderInstance() {
    // tabsSlider.call(this);
    // };

    this.state = {
      isSwipe: false,
      currentIndex: props.defaultTabNumber || 0,
      ...{
        displayType: 'flex',
        tabsContainerCssClass: 'tabsSlider--tabsWrapper',
        tabCssClass: 'tabsSlider--tab',
        activeTabCssClass: 'tabsSlider--tab-active',
        menuContainerCssClass: 'tabsSlider--menuWrapper',
        menuCssClass: 'tabsSlider--menu',
        activeMenuCssClass: 'tabsSlider--menu-active',
        menuUnderlineCssClass: 'tabsSlider--menuUnderline',
        defaultTabNumber: 0,
      },
      ...(props.tabsContainerCssClass
        ? {
            tabsContainerCssClass: props.tabsContainerCssClass,
          }
        : {}),
      ...(props.tabCssClass
        ? {
            tabCssClass: props.tabCssClass,
          }
        : {}),
      ...(props.activeTabCssClass
        ? {
            activeTabCssClass: props.activeTabCssClass,
          }
        : {}),
      ...(props.menuContainerCssClass
        ? {
            menuContainerCssClass: props.menuContainerCssClass,
          }
        : {}),
      ...(props.menuCssClass
        ? {
            menuCssClass: props.menuCssClass,
          }
        : {}),
      ...(props.activeMenuCssClass
        ? {
            activeMenuCssClass: props.activeMenuCssClass,
          }
        : {}),
      ...(props.menuUnderlineCssClass
        ? {
            menuUnderlineCssClass: props.menuUnderlineCssClass,
          }
        : {}),
      ...(props.defaultTabNumber
        ? {
            defaultTabNumber: props.defaultTabNumber,
          }
        : {}),
      ...(props.display
        ? {
            display: props.display,
          }
        : {}),
      ...(props.displayType
        ? {
            displayType: props.displayType,
          }
        : {}),
    };

    this.touchStartX = null;
    this.touchStartY = null;

    this.touchMoveX = null;
    this.touchMoveY = null;
    this.isSwipe = false;
    this.velocityX = null;
    this.velocityY = null;
  }

  componentDidMount() {
    this.setupThreshold();
  }

  componentDidUpdate(prevProps) {
    const prevTabs = Children.map(prevProps.children, (c) => c?.props?.name);
    const nextTabs = Children.map(this.props.children, (c) => c?.props?.name);

    if (nextTabs.length !== prevTabs.length) {
      this.selectMenu(0);
      this.selectTab(0);
    }
  }

  getElementWidth = (element) => {
    if (element) {
      var style = element.style;

      return (
        element.offsetWidth +
        parseFloat(style.marginLeft || 0) +
        parseFloat(style.marginRight || 0) -
        parseFloat(style.paddingLeft || 0) -
        parseFloat(style.paddingRight || 0) +
        parseFloat(style.borderLeftWidth || 0) +
        parseFloat(style.borderRightWidth || 0)
      );
    }
  };

  getElementPadding = (element) => {
    var style = element.style;

    return (
      parseFloat(style.paddingLeft || 0) + parseFloat(style.paddingRight || 0)
    );
  };

  setupThreshold = () => {
    const thresholdX = Math.max(
      25,
      Math.floor(0.15 * (window.innerWidth || document.body.clientWidth))
    );
    const thresholdY = Math.max(
      25,
      Math.floor(0.15 * (window.innerHeight || document.body.clientHeight))
    );

    this.setState({
      thresholdX,
      thresholdY,
    });
  };

  getUnderlineTranslateXForMobile = (index) => {
    var totalWidth = 0;
    var i = 0;

    for (i; i <= index; i++) {
      if (i === index) {
        totalWidth =
          totalWidth + this.getElementWidth(this.menus.current[i]) / 2;
      } else {
        totalWidth = totalWidth + this.getElementWidth(this.menus.current[i]);
      }
    }

    return totalWidth;
  };

  startSwipe = () => {
    this.isSwipe = true;
    setTimeout(() => {
      // prepare prev tab - none
      if (this.tabs.current[this.state.currentIndex - 1]) {
        this.addTabPositionCss(
          this.tabs.current[this.state.currentIndex - 1],
          this.state.displayType,
          'absolute'
        );
      }

      // prepare next tab
      if (this.tabs.current[this.state.currentIndex + 1]) {
        this.addTabPositionCss(
          this.tabs.current[this.state.currentIndex + 1],
          this.state.displayType,
          'absolute'
        );
      }

      this.addTabPositionCss(
        this.tabs.current[this.state.currentIndex],
        this.state.displayType,
        'initial'
      );
      if (this.state.currentIndex !== null) {
        this.addTabPositionCss(
          this.tabs.current[this.state.currentIndex],
          this.state.displayType,
          'absolute'
        );
      }

      this.finishSwipe();

      let userAgent = navigator.userAgent || navigator.vendor || window.opera;
      // new tab should always start from top

      if (/android/i.test(userAgent)) {
        let rootElem = document.getElementById('root');
        if (rootElem) {
          rootElem.scrollTo({ top: 0 });
        }
      }
      window.scroll(0, 0);
    }, 200);
  };

  finishSwipe = () => {
    this.setState({ isSwipe: false });
    this.isSwipe = false;
  };

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
  }

  addTabAnimationCss = (element, transform, opacity) => {
    if (element) {
      element.style.opacity = opacity.toString();
      element.style.transform = 'translate3d(' + transform + '%,0,0)';
      if (transform != '0') {
        element.style.overflow = 'hidden';
      } else {
        element.style.overflow = 'auto';
      }
      // element.style.pointerEvents = 'none'
    }
  };

  getDefaultValues = () => {
    return {
      tabsContainerCssClass: 'tabsSlider--tabsWrapper',
      tabCssClass: 'tabsSlider--tab',
      activeTabCssClass: 'tabsSlider--tab-active',
      menuContainerCssClass: 'tabsSlider--menuWrapper',
      menuCssClass: 'tabsSlider--menu',
      activeMenuCssClass: 'tabsSlider--menu-active',
      menuUnderlineCssClass: 'tabsSlider--menuUnderline',
      defaultTabNumber: 0,
    };
  };

  applyDefaultConfig = (config) => {
    this.setState({
      ...config,
      ...this.getDefaultValues(),
    });
  };

  isMenuStart = (index, widthToCompare) => {
    var menuStartCount = 0;
    var i = 0;

    for (i; i <= this.menus.current.length; i++) {
      if (this.menus.current[i]) {
        var elementWidth = this.getElementWidth(this.menus.current[i]);
        if (menuStartCount + elementWidth / 2 < widthToCompare / 2) {
          menuStartCount = menuStartCount + elementWidth;
        } else {
          break;
        }
      }
    }

    return i - 1 >= index;
  };

  isMenuEnd = (index, widthToCompare) => {
    var menuStartCount = 0;
    var i = this.menus.current.length - 1;

    for (i; i >= 0; i--) {
      var elementWidth = this.getElementWidth(this.menus.current[i]);

      if (menuStartCount + elementWidth / 2 < widthToCompare / 2) {
        menuStartCount = menuStartCount + elementWidth;
      } else {
        break;
      }
    }

    return i + 1 <= index;
  };

  getUnderlineTranslateXForStart = (index) => {
    var myStyle = this.menus.current[index].style;
    var underlineTranslateX = parseFloat(myStyle.marginLeft || 0);
    var i = index - 1;

    for (i; i >= 0; i--) {
      underlineTranslateX =
        underlineTranslateX + this.getElementWidth(this.menus.current[i]);
    }

    return underlineTranslateX;
  };

  getUnderlineTranslateXForEnd = (index) => {
    var underlineTranslateX = this.getElementPadding(
      this.menusContainer.current
    );
    var i = index;

    for (i; i < this.menus.current.length; i++) {
      underlineTranslateX =
        underlineTranslateX + this.getElementWidth(this.menus.current[i]);
    }
    underlineTranslateX =
      this.menusContainer.current.offsetWidth - underlineTranslateX;

    return underlineTranslateX;
  };

  getUnderlineTranslateXForDesktop = (index) => {
    var totalWidth = 0;
    var i = 0;

    for (i; i < index; i++) {
      totalWidth = totalWidth + this.getElementWidth(this.menus.current[i]);
    }
    return totalWidth;
  };

  selectMenu = (index) => {
    // default
    var underlineTranslateX = 0;
    var menuTranslateX = 0;
    let widthToCompare = window.innerWidth;
    if (widthToCompare > 992) {
      if (this.state.menuCssClass === 'tabsSlider2--menu') {
        widthToCompare = document.getElementsByClassName(
          'extraScreen active'
        )[0]
          ? document.getElementsByClassName('extraScreen active')[0].offsetWidth
          : window.innerWidth;
      }
    }

    // move menu only if menu is longer than window width
    if (this.menusContainer.current) {
      if (this.menusContainer.current.offsetWidth > widthToCompare) {
        // move menu to the start
        if (this.isMenuStart(index, widthToCompare)) {
          menuTranslateX = 0;
          underlineTranslateX = this.getUnderlineTranslateXForStart(index);
          // move menu to the end
        } else if (this.isMenuEnd(index, widthToCompare)) {
          menuTranslateX = -(
            this.menusContainer.current.offsetWidth - widthToCompare
          );
          underlineTranslateX = this.getUnderlineTranslateXForEnd(index);
          // selected item is in the middle
        } else {
          var totalWidth = this.getUnderlineTranslateXForMobile(index);
          // start moving the menu only if the item overpass the middle of the screen
          if (totalWidth > widthToCompare / 2) {
            menuTranslateX = -(totalWidth - widthToCompare / 2);
            underlineTranslateX =
              totalWidth - this.getElementWidth(this.menus.current[index]) / 2;
          }
        }
      } else {
        let elems = document.getElementsByClassName(
          'tabsSlider2--menuContainer'
        );
        if (elems[0]) {
          for (let i = 0; i < elems.length; i++) {
            elems[i].style.width = '100%';
          }
        }
        underlineTranslateX = this.getUnderlineTranslateXForDesktop(index);
        if (index === 0 && this.state.menuCssClass === 'tabsSlider2--menu') {
          underlineTranslateX = 20;
        }
      }
    }

    this.resizeUnderlineCss(index);
    this.addUnderlineAnimationCss(underlineTranslateX);
    this.addMenuAnimationCss(menuTranslateX);
  };

  addMenuAnimationCss = (position) => {
    if (this.menusContainer.current)
      this.menusContainer.current.style.transform =
        'translateX(' + position + 'px)';
  };

  addUnderlineAnimationCss = (position) => {
    if (this.menuUnderline)
      this.menuUnderline.current.style.transform =
        'translateX(' + position + 'px)';
  };

  resizeUnderlineCss = (index) => {
    if (this.menuUnderline)
      this.menuUnderline.current.style.width =
        this.menus.current[index].offsetWidth + 'px';
  };

  getCurrentMenuTransition = () => {
    return Number(
      this.menusContainer.current.style.transform.replace(/[^\d.]/g, '')
    );
  };

  addTabPositionCss = (element, display, position) => {
    if (element) {
      element.style.display = display;
      element.style.position = position;

      // preventing blinking
      // if (display !== style.display) {
      // element.style.display = display;
      // }

      // preventing blinking
      // if (position !== style.position) {
      // element.style.position = position;
      // }
    }
  };

  resetOnTouch = (element) => {
    this.addTabAnimationCss(element, 0, 1);
    if (element.nextElementSibling) {
      this.addTabAnimationCss(element.nextElementSibling, 100, 1);
    }
    if (element.previousElementSibling) {
      this.addTabAnimationCss(element.previousElementSibling, -100, 1);
    }
    this.finishSwipe();
  };

  isValidConfig = (config) => {
    return (
      !!config &&
      typeof config.tabsContainerCssClass == 'string' &&
      config.tabsContainerCssClass.length > 0 &&
      typeof config.tabCssClass == 'string' &&
      config.tabCssClass.length > 0 &&
      typeof config.activeTabCssClass == 'string' &&
      config.activeTabCssClass.length > 0 &&
      typeof config.menuContainerCssClass == 'string' &&
      config.menuContainerCssClass.length > 0 &&
      typeof config.menuCssClass == 'string' &&
      config.menuCssClass.length > 0 &&
      typeof config.activeMenuCssClass == 'string' &&
      config.activeMenuCssClass.length > 0 &&
      typeof config.menuUnderlineCssClass == 'string' &&
      config.menuUnderlineCssClass.length > 0 &&
      typeof config.defaultTabNumber == 'number'
    );
  };

  styleTab =
    (currentIndex, newIndex, addTabPositionCss, addTabAnimationCss) =>
    (element, index) => {
      if (index !== newIndex && index !== currentIndex) {
        addTabPositionCss(element, 'none', 'absolute');
        // send to left
        if (index < newIndex) {
          addTabAnimationCss(element, -100, 1);
          // send to right
        } else {
          addTabAnimationCss(element, 100, 1);
        }
      }
    };

  selectTab = (newIndex) => {
    this.addTabPositionCss(
      this.tabs.current[newIndex],
      this.state.displayType,
      'absolute'
    );

    if (newIndex === this.state.currentIndex) return;

    // do nothing if user click on the same element

    const finishTabsStyling = (resolve) => {
      // prepare prev tab - none
      if (this.tabs.current[newIndex - 1]) {
        this.addTabPositionCss(
          this.tabs.current[newIndex - 1],
          this.state.displayType,
          'absolute'
        );
      }

      // prepare next tab
      if (this.tabs.current[newIndex + 1]) {
        this.addTabPositionCss(
          this.tabs.current[newIndex + 1],
          this.state.displayType,
          'absolute'
        );
      }

      this.addTabPositionCss(
        this.tabs.current[newIndex],
        this.state.displayType,
        'initial'
      );
      if (this.state.currentIndex !== null) {
        this.addTabPositionCss(
          this.tabs.current[this.state.currentIndex],
          this.state.displayType,
          'absolute'
        );
      }

      // all the styling applied, now the new tab is selected
      this.setState({
        currentIndex: newIndex,
      });

      this.finishSwipe();

      let userAgent = navigator.userAgent || navigator.vendor || window.opera;
      // new tab should always start from top

      if (/android/i.test(userAgent)) {
        let rootElem = document.getElementById('root');
        if (rootElem) {
          rootElem.scrollTo({ top: 0 });
        }
      }
      window.scroll(0, 0);

      setTimeout(resolve, 10);
    };

    const updateTabsPositions = (resolve) => {
      // this.tabs.current.forEach((tab, index) => this.styleTab(this.state.currentIndex, newIndex, tab, index))
      Array.prototype.forEach.call(
        this.tabs.current,
        this.styleTab(
          this.state.currentIndex,
          newIndex,
          this.addTabAnimationCss,
          this.addTabPositionCss
        )
      );

      setTimeout(resolve, 50);
    };

    const updateNewAndCurrentTabs = (resolve) => {
      if (this.state.currentIndex !== null) {
        // move current tab to left
        if (newIndex > this.state.currentIndex) {
          this.addTabAnimationCss(
            this.tabs.current[this.state.currentIndex],
            -100,
            0
          );
          // move current tab to right
        } else {
          this.addTabAnimationCss(
            this.tabs.current[this.state.currentIndex],
            100,
            0
          );
        }
      }

      // update current tab
      this.addTabAnimationCss(this.tabs.current[newIndex], 0, 1);

      setTimeout(resolve, 200);
    };
    var updateTabsPositionsPromise = new Promise(updateTabsPositions);

    // using promises to ensure sequence and timeout to apply style changes
    updateTabsPositionsPromise
      .then(new Promise(updateNewAndCurrentTabs))
      .then(new Promise(finishTabsStyling))
      .then(() => {
        this.timeoutId = setTimeout(() => {
          document.querySelectorAll('.itemBoxes').forEach((el) => {
            el.style.webkitTouchCallout = 'initial';
            el.style.pointerEvents = 'initial';
            el.style.touchAction = 'initial';
          });
        }, 400);
      });
  };

  onTouchStart = (event) => {
    this.touchStartX = event.changedTouches[0].screenX;
    this.touchStartY = event.changedTouches[0].screenY;

    this.setState({
      // reset rest
      touchMoveX: null,
      touchMoveY: null,
      touchEndX: null,
      touchEndY: null,
    });
  };

  onTouchMove = (event, index) => {
    var moveX = event.changedTouches[0].screenX - this.touchStartX;
    var moveY = event.changedTouches[0].screenY - this.touchStartY;

    this.velocityX = moveX - this.touchMoveX;
    this.touchMoveX = moveX;

    this.velocityY = moveY - this.touchMoveY;
    this.touchMoveY = moveY;

    // if swipe is horizontal
    if (
      Math.abs(moveX) > this.state.thresholdX &&
      Math.abs(moveX) > Math.abs(moveY)
    ) {
      if (
        (moveX < -10 && index + 1 < this.tabs.current.length) ||
        (moveX > 10 && index - 1 >= 0)
      ) {
        this.addTabAnimationCss(
          this.tabs.current[index],
          ((this.touchMoveX / window.innerWidth) * 100).toFixed(2),
          1 - (Math.abs(this.touchMoveX) / window.innerWidth).toFixed(3)
        );

        if (this.tabs.current[index - 1]) {
          // animate tab
          this.addTabAnimationCss(
            this.tabs.current[index - 1],
            -(100 - ((this.touchMoveX / window.innerWidth) * 100).toFixed(2)),
            1
          );
          // animate underline
        }
        if (this.tabs.current[index + 1]) {
          // animate tab
          this.addTabAnimationCss(
            this.tabs.current[index + 1],
            100 + Number(((moveX / window.innerWidth) * 100).toFixed(2)),
            1
          );
          // animate underline
        }
      }
    }
  };
  /* // prevent vertical scroll at the time horizontal scroll already started
      if (Math.abs(this.touchMoveY) > 1) {
        event.preventDefault();
        event.stopPropagation();
      }
      // on user swipe and new tab is in scope of tabs
      if (index <= this.tabs.current.length || index > 0) {
        if (
          (index !== 0 && index !== this.tabs.current.length - 1) ||
          (index === 0 && this.touchMoveX < 0) ||
          (index === this.tabs.current.length - 1 && this.touchMoveX > 0)
        ) {
          this.addTabAnimationCss(
            this.tabs.current[index],
            ((this.touchMoveX / window.innerWidth) * 100).toFixed(2),
            1 - (Math.abs(this.touchMoveX) / window.innerWidth).toFixed(3)
          );
          if (Math.abs(this.touchMoveX) >= 15) {
            this.tabs.current[index].style.touchAction = 'none';
          }
        }

        if (Math.abs(this.touchMoveY) <= 100) {
          if (this.tabs.current[index - 1] && this.touchMoveX > 0) {
            // animate tab
            this.addTabAnimationCss(
              this.tabs.current[index - 1],
              -(
                100 - ((this.touchMoveX / window.innerWidth) * 100).toFixed(2)
              ),
              1
            );
            // animate underline
          } else if (this.tabs.current[index + 1] && this.touchMoveX < 0) {
            // animate tab
            this.addTabAnimationCss(
              this.tabs.current[index + 1],
              100 + parseFloat((this.touchMoveX / window.innerWidth) * 100),
              1
            );
            // animate underline
          }
        }
      } 
    }
  };*/

  onTouchEnd = (event, index) => {
    if (!this.isSwipe) {
      this.startSwipe();
      const {
        changedTouches: [{ screenX, screenY }],
      } = event;

      var x = screenX - this.touchStartX;
      var y = screenY - this.touchStartY;

      const element = this.tabs.current[index];

      // if swiped is horizontal
      if (
        Math.abs(x) > this.state.thresholdX &&
        Math.abs(x) >= Math.abs(y) &&
        Math.abs(y) <= (/android/i.test(userBrowser) ? 100 : 20)
      ) {
        // swipe left
        if (
          x < 0 &&
          index + 1 < this.tabs.current.length &&
          (this.velocityX < -1.5 || x < -Math.floor(0.1 * element.offsetWidth))
        ) {
          this.selectMenu(index + 1);
          this.selectTab(index + 1);
          // swipe right
        } else if (
          x > 0 &&
          index - 1 >= 0 &&
          (this.velocityX > 1.5 || x > Math.floor(0.1 * element.offsetWidth))
        ) {
          this.selectMenu(index - 1);
          this.selectTab(index - 1);
          // reset to default
        } else {
          this.resetOnTouch(element);
        }
        // reset to default */
      } else {
        this.resetOnTouch(element);
      }
      element.style.touchAction = 'unset';
      document.querySelector('.container-fluid.shadowIt').style.overflowY =
        'auto';
      document.querySelectorAll('.itemBoxes').forEach((el) => {
        el.style['-webkit-touch-callout'] = 'initial';
        el.style.pointerEvents = 'initial';
      });
      // let _tabs = document.querySelectorAll('.itemBoxes a');
      // if (_tabs[0]) {
      // for (let i = 0; i < _tabs.length - 1; i++) {
      // _tabs[i].style.pointerEvents = 'initial';
      // }
      // }
      // bodyDoc.style.overflowY = 'unset';
      // bodyDoc.style.position = 'inherit';
      // tabsContainer[0].style.position = 'relative';

      // reset to default
      this.touchMoveX = null;
      setTimeout(() => {
        window.sliderMOVING = false;
      }, 250);
    }
  };

  render() {
    const { children, containerStyle, portalMenu } = this.props;

    return (
      <>
        <TabsSliderMenuContainer
          portal={portalMenu}
          ref={this.menusContainer}
          onTouchStart={(e) => {
            const {
              changedTouches: [{ screenX }],
            } = e;
            this.setState({
              menuTouchStartX: screenX,
              menuTouchStartPos: this.getCurrentMenuTransition(),
            });
          }}
          onTouchMove={(e) => {
            const {
              changedTouches: [{ screenX }],
            } = e;
            const maxNewPos =
              window.innerWidth - this.menusContainer.current.offsetWidth - 10;
            const diff =
              screenX -
              this.state.menuTouchStartX -
              this.state.menuTouchStartPos;
            const newPos = diff > 0 ? 0 : diff >= maxNewPos ? diff : maxNewPos;

            this.addMenuAnimationCss(newPos);
          }}
          onTouchEnd={() => {
            this.setState({ menuTouchStartX: null });
          }}
          _className={this.state.menuContainerCssClass}
        >
          <ul className='tabsSlider--menuList'>
            <div style={{ whiteSpace: `nowrap` }}>
              {Children.map(children, (Tab, i) => {
                return (
                  <TabsSliderMenu
                    label={Tab?.props?.name || ''}
                    ref={(c) => (this.menus.current[i] = c)}
                    onClick={() => {
                      if (i !== this.state.currentIndex) {
                        this.selectMenu(i);
                        this.selectTab(i);
                      }
                    }}
                    _className={
                      this.state.menuCssClass +
                      (i === this.state.currentIndex
                        ? ` ${this.state.menuCssClass}-active`
                        : '')
                    }
                    index={i}
                  />
                );
              })}
              <div
                ref={this.menuUnderline}
                className={this.state.menuUnderlineCssClass}
              />
            </div>
          </ul>
        </TabsSliderMenuContainer>
        <TabsSliderContainer
          style={containerStyle}
          ref={this.tabsContainer}
          _className={this.state.tabsContainerCssClass}
        >
          {Children.map(children, (Tab, i) => {
            if (Tab === null) return null;
            return React.cloneElement(Tab, {
              ref: (c) => (this.tabs.current[i] = c),
              currentIndex: this.state.currentIndex,
              index: i,
              onTouchStart: this.onTouchStart,
              onTouchMove: (e) => this.onTouchMove(e, i),
              onTouchEnd: (e) => this.onTouchEnd(e, i),
              _className:
                this.state.tabCssClass +
                (i === this.state.currentIndex
                  ? ` ${this.state.tabCssClass}-active`
                  : ''),
            });
          })}
        </TabsSliderContainer>
      </>
    );
  }
}

TabsSlider.Container = TabsSliderContainer;

TabsSlider.Tab = TabsSliderTab;

export default TabsSlider;
